"use strict";

function BtnDeleteController($scope, $state, $stateParams, common, ModalService, FlashBag) {
    var _this = this;
    this.btnClass = (typeof this.btnClass !== "undefined") ? this.btnClass : "btn btn-default";

    $scope.delete = function() {
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "selector",
            inputs: {
                $attrs: {
                    title: _this.modalTitle,
                    message: _this.modalMessage
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                FlashBag.clearAll();
                if (result) {
                    _this.deleteFunction(_this.objectId).then(function() {
                        if (_this.successMessage) {
                            common.scrollToTop();
                            FlashBag.success(_this.successMessage, true);
                        }

                        if (_this.redirectState) {
                            if (_this.redirectParams) {
                                return $state.go(_this.redirectState, _this.redirectParams);
                            }
                            return $state.go(_this.redirectState);
                        }
                        else if (_this.onDeleteCallbackFunction) {
                            _this.onDeleteCallbackFunction(_this.objectId);
                        }
                        else {
                            window.history.back();
                        }
                    });
                }
            });
        });
    };
}

angular.module("core").component("btnDelete", {
    templateUrl: require("./btn-delete.component.html"),
    controller: BtnDeleteController,
    bindings: {
        deleteFunction: "<",
        objectId: "<",
        modalTitle: "<",
        modalMessage: "<",
        successMessage: "<?",
        redirectState: "<?",
        redirectParams: "<?",
        onDeleteCallbackFunction: "<?",
        btnTextValue: "<?",
        btnClass: "@?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/btn-delete/btn-delete.component.js
// module id = 576
// module chunks = 0